import React, { useEffect, useState } from 'react';
import Footer from "./Footer";
import Header from "./Header";
import image2 from "../Assets/wp3589952.webp";
import axios from 'axios';
import { Link } from "react-router-dom";
import './Terms.css';

function Terms() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [termsContent, setTermsContent] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchTermsData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { terms } = response.data.body;

        // Ensure content is a string and trim whitespace
        setTermsContent(terms?.value?.trim() || "");
      } catch (error) {
        console.error("Error fetching the terms content", error);
        setTermsContent(""); // Set empty content on error
      } finally {
        setIsLoading(false); // Stop loading after data is fetched
      }
    };

    fetchTermsData();
  }, []);

  return (
    <div>
      <div className="main">
        <Header />

        <div
  className="content-section"
  style={{ backgroundImage: `url(${image2})` }} 
>
          <h1
            style={{
              color: "white",
              
              textAlign: "center",
            }}
          >
            Terms & Conditions
          </h1>
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              color: "white",
            }}
          >
            <Link to="/" style={{color:"white"}}>
              Home
            </Link> <i className="bi bi-chevron-right"></i> Terms & Conditions
          </p>
        </div>

        <div className='terms-content' style={{ padding: "20px" }}>
          {/* Prevent flickering of "No content available" while loading */}
          {isLoading ? null : (
            termsContent ? (
              <div dangerouslySetInnerHTML={{ __html: termsContent }} />
            ) : (
              <p>No content available</p>
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
